import React from 'react';
import { useTranslation } from 'react-i18next';
import iccLogo from '../assets/images/icc.svg';
import { appConfig } from '../config';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const baseUri = `https://core.${appConfig['base-uri']}`;

  return (
    <footer className="u-footer">
      <div className="u-logos">
        <a href="https://iccwbo.org" target="_blank" rel="noopener">
          <img src={iccLogo} alt={t('footer.iccAlt')} />
        </a>
      </div>

      <nav className="u-items t-sm-bold">
        <a href={`${baseUri}/Static/TermsConditions.html`}>
          <span>{t('footer.termsConditions')}</span>
        </a>
        <a href={`${baseUri}/Static/PrivacyPolicyCore.html`}>
          <span>{t('footer.privacyPolicy')}</span>
        </a>
      </nav>

      <div className="u-infos t-xs-bold">
        <div className="left">
          {t('footer.copyright')}{' '}
          <a href="https://www.uditis.ch" target="_blank" rel="noopener">
            UDITIS
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
